import axios from "axios";
import mockData from "./mockData";
import { REACT_APP_VERCEL_ENV, REACT_APP_ENV } from "../env";

/**
 * Centralized API service that returns mock data in local environment
 * and makes real API calls in other environments
 */
class ApiService {
  constructor() {
    this.environment = this.getEnvironment();
    axios.defaults.withCredentials = true;
  }

  getEnvironment() {
    const vercelEnvironment = REACT_APP_VERCEL_ENV;
    const isLocalhost = typeof window !== 'undefined' && 
      (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
    
    if (vercelEnvironment === "production") {
      return 'production';
    } else if (vercelEnvironment === "preview") {
      return 'staging';
    } else if (vercelEnvironment === "lando" || REACT_APP_ENV === "lando") {
      return 'lando';
    } else if (isLocalhost) {
      if (REACT_APP_ENV === "lando") {
        return 'lando';
      }
      return 'local';
    } else if (vercelEnvironment === undefined) {
      return 'local';
    }
    return 'local';
  }

  /**
   * Main GET method that routes to mock or real API
   */
  async get(url, config = {}) {
    if (this.environment === 'local') {
      return this.getMockData(url);
    }
    return axios.get(url, config);
  }

  /**
   * POST method (always uses real API, even in local)
   */
  async post(url, data, config = {}) {
    return axios.post(url, data, config);
  }

  /**
   * Returns mock data based on URL pattern
   */
  getMockData(url) {
    return new Promise((resolve, reject) => {
      // Simulate network delay
      setTimeout(() => {
        try {
          let mockResponse = null;

         // Match URL patterns to mock data
                 if (url.includes('/cmp/account-info')) {
                   mockResponse = { data: mockData.accountInfo };
                 } else if (url.includes('/cmp/layout')) {
                   mockResponse = { data: mockData.layout };
                 } else if (url.includes('/cmp/benefits/resources')) {
                   mockResponse = { data: mockData.benefits.resources };
                 } else if (url.includes('/cmp/benefits?key_only=true')) {
                   mockResponse = { data: mockData.benefits.keyBenefits };
                 } else if (url.includes('/cmp/benefits')) {
                   mockResponse = { data: mockData.benefits.allBenefits };
                 } else if (url.includes('/cmp/events')) {
                   mockResponse = { data: mockData.events };
                 } else if (url.includes('/cmp/articles')) {
                   mockResponse = { data: mockData.articles };
                 } else if (url.includes('/cmp/novoed')) {
                   mockResponse = { data: mockData.novoed };
                 } else if (url.includes('/course-recommendations/')) {
                   mockResponse = { data: mockData.recommendations };
                 } else if (url.includes('/cmp/sponsorship-opportunities')) {
                   mockResponse = { data: mockData.sponsorshipOpportunities };
                 } else {
                   reject(new Error(`No mock data found for URL: ${url}`));
                   return;
                 }

          resolve(mockResponse);
        } catch (error) {
          reject(error);
        }
      }, 500); // 500ms delay to simulate network
    });
  }
}

// Export singleton instance
export default new ApiService();
